// extracted by mini-css-extract-plugin
export default {"filesList":"styles_filesList__ELwjy","fileItem":"styles_fileItem__ZGGDu","fileSize":"styles_fileSize__LrMT+","deleteFile":"styles_deleteFile__cwKri"};